const BASE_URL = "https://api.collegefairs.ae";
export { BASE_URL };
